import { create } from "zustand";
import {
  fetchPrompts,
  fetchPromptById,
  createPrompt,
  updatePrompt,
  deletePrompt as apiDeletePrompt,
} from "./promptsApi";
import { notifications } from "@mantine/notifications";
import i18n from "../i18n";

export const usePromptsStore = create((set, get) => ({
  prompts: null,
  isLoading: true,
  deletePrompt: async (promptId) => {
    set({ isLoading: true });
    try {
      await apiDeletePrompt(promptId);
      // Remove the deleted prompt from the store
      const prompts = get().prompts?.filter((p) => p.id !== promptId) || [];
      set({ prompts, isLoading: false });
      notifications.show({
        title: i18n.t(
          "prompts.notifications.delete_success",
          "Prompt deleted successfully"
        ),
        color: "green",
      });
    } catch (err) {
      notifications.show({
        title: i18n.t(
          "prompts.notifications.delete_failed",
          "Failed to delete prompt"
        ),
        color: "red",
      });
      set({ isLoading: false });
      throw err;
    }
  },

  createPrompt: async (promptData) => {
    set({ isLoading: true });
    const createdPrompt = await createPrompt(promptData);
    console.log("Created prompt:", createdPrompt);
    set({ isLoading: false, prompts: [...get().prompts, createdPrompt] });
    return createdPrompt;
  },

  updatePrompt: async (promptId, promptData) => {
    set({ isLoading: true });
    try {
      const updatedPrompt = await updatePrompt(promptId, promptData);
      const prompts = get().prompts;
      const updatedPrompts = prompts.map((prompt) =>
        prompt.id === promptId ? updatedPrompt : prompt
      );
      set({ prompts: updatedPrompts, isLoading: false });
      return updatedPrompt;
    } catch (err) {
      notifications.show({
        title: i18n.t(
          "prompts.notifications.update_failed",
          "Failed to update prompt"
        ),
        color: "red",
      });
      set({ isLoading: false });
      throw err;
    }
  },

  fetchPrompts: async (brandId) => {
    if (!brandId || brandId === "undefined") {
      set({ prompts: [], isLoading: false });
      return;
    }
    set({ isLoading: true });
    try {
      const prompts = await fetchPrompts(brandId);
      set({
        prompts: prompts,
        isLoading: false,
      });
    } catch (err) {
      notifications.show({
        title: i18n.t(
          "prompts.notifications.fetch_failed",
          "Failed to fetch prompts"
        ),
        color: "red",
      });
      set({ isLoading: false });
    }
  },

  getPromptById: async (promptId) => {
    const existingPrompt = get().prompts?.find((p) => p.id === promptId);
    if (existingPrompt) {
      console.log("Prompt found in store:", existingPrompt);
      return existingPrompt;
    }
    console.log("Prompt not found in store, fetching:", promptId);
    // If prompt is not in the store, fetch it:
    set({ isLoading: true });
    try {
      const prompt = await fetchPromptById(promptId);
      set({
        prompts: [...get().prompts, prompt],
        isLoading: false,
      });
    } catch (err) {
      notifications.show({
        title: i18n.t(
          "prompts.notifications.fetch_failed",
          "Failed to fetch prompt"
        ),
        color: "red",
      });
    }
  },
}));
